import React, { useMemo } from 'react';
import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import DataTable from 'shared/components/table/DataTable';
import { searchTickets } from 'shared/api/support';
import { CardSection } from 'shared/components/cardControls';
import { defaultSearch } from 'shared/utils';
import { FILTER_DISPLAY_TYPE, VARIANTS } from 'shared/constants';
import { withSelectorSwitch } from 'shared/components/data-display/editors';
import { getTicketSubjectPath } from 'shared/routes/support';
import { FilterRedirect } from 'shared/hoc/withFilters';
import { withStaticSelect } from 'shared/components/data-display/withSelectors';
import { ticketIconColumns } from 'shared/components/table/ticketColumns';
import { TICKET_STATUS_OPTIONS } from 'shared/constants/support';
import { Section } from 'shared/components/styled/layouts';

const buildingFilters = [
  {
    param: 'status',
    label: 'Status',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withStaticSelect({
      disableClearable: true,
      options: TICKET_STATUS_OPTIONS,
    }),
  },
  {
    label: 'Show Tenant Tickets',
    param: 'show_tenants',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
  {
    label: 'Show Unit Tickets',
    param: 'show_units',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
];

/**
 * @param {Object<string, *>} buildingState - The building state object
 * @param {string} path - Current path
 * @param {string} savedFilters - Saved filter parameters
 * @param {string} filterKey - Key for filtering
 */
export default function BuildingTickets({
  buildingState: {
    data: building,
  },
  path,
  savedFilters,
  filterKey,
}) {
  const { search } = useLocation();

  const { id } = building;

  const baseSearch = useMemo(() => defaultSearch(
    search,
    {
      building_id: id,
      unit_id: 0,
      tenant_id: 0,
      with_association: 'True',
    },
  ), [id, search]);

  if (!FilterRedirect(path, savedFilters)) {
    return (
      <CardSection>
        <Section>
          <DataTable
            noSearchForm
            noExportButton
            filters={buildingFilters}
            filterKey={filterKey}
            columns={ticketIconColumns}
            searchRequest={searchTickets}
            baseSearch={baseSearch}
            rowId="id"
          />
          <div style={{
            paddingTop: 10,
            textAlign: 'right',
          }}
          >
            <Button
              href={getTicketSubjectPath(id)}
              startIcon={<Add />}
              variant={VARIANTS.contained}
              sx={{ '&:hover': { color: 'common.white' } }}
              target="_blank"
            >
              Create Ticket
            </Button>
          </div>
        </Section>
      </CardSection>
    );
  }
}
